import React from 'react';
import PropTypes from 'prop-types';

import ImageLoad from '../common/ImageLoad';
import TenantService from 'App/services/tenant';

import './restaurant-menu-hero.scss';

export function hasHeroImages(restaurant = {}) {
  return restaurant && !!restaurant.hero_images;
}

const RestaurantMenuHero = props => {
  const { restaurant } = props;
  const placeholderSrc = TenantService.getPlaceholderImageForRestaurantHero();
  if (!hasHeroImages(restaurant)) {
    return null;
  }
  return <div className="restaurant-menu-hero">
    {restaurant.hero_images.slice(0, 6).map((img, index) => <figure className="restaurant-menu-hero__item" key={img}>
      <ImageLoad
        className="restaurant-menu-hero__img"
        loadingClassName="restaurant-menu-hero__loader"
        src={img}
        placeholder={placeholderSrc}
        alt={`Zdjęcie jedzenia ${index + 1} z restauracji ${restaurant.name}`}
      />
    </figure>)}
  </div>;
}

RestaurantMenuHero.propTypes = {
  restaurant: PropTypes.object.isRequired,
};

export default RestaurantMenuHero;
